import { Component, OnInit, inject } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";

@Component({
  selector: "app-launch-component",
  template: "",
})
export class LaunchComponent implements OnInit {
  private router = inject(Router);

 

  async ngOnInit(): Promise<void> {
    const extras: NavigationExtras = {};

    await this.router.navigate(["/login"], extras);
  }
}
